import { render, staticRenderFns } from "./add-attachment.vue?vue&type=template&id=4ac5fcc4&scoped=true&"
import script from "./add-attachment.vue?vue&type=script&lang=js&"
export * from "./add-attachment.vue?vue&type=script&lang=js&"
import style0 from "./add-attachment.vue?vue&type=style&index=0&id=4ac5fcc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5fcc4",
  null
  
)

export default component.exports